import React, { useContext, Fragment } from "react";
import Link from "./Link";
import { Context } from "Context";
import AccessibleText from "./AccessibleText";
import { trackLink } from "utils/analyticsFramework";

const mainClass = "syndicated-button";

const getClasses = ({ className, customStyles, brand, secondary, link }) => {
	let classes = className;
	if (!customStyles) {
		classes += ` ${mainClass}`;
		classes += ` ${mainClass}--${brand}`;
		classes += ` ${mainClass}--${secondary ? "secondary" : "primary"}`;
		classes += ` ${mainClass}--${link ? "link" : "button"}`;
	}
	return classes;
};

const handleTriggerAnalytics = (e, analyticsLinkId) => {
	if (analyticsLinkId) {
		const linkId = `${analyticsLinkId}_${
			e.type === "click" ? "CLICK" : "HOVER"
		}`;
		if (analyticsLinkId) {
			trackLink({ linkId });
		}
	}
};

const Button = ({
	elementId = null,
	ariaLabel = null,
	ariaExpanded = null,
	accessibleText = "",
	children,
	className = "",
	customStyles = false,
	disabled = null,
	link = false,
	linkContent = {},
	onClick = null,
	secondary = false,
	tabIndex = 0,
	title,
	style = null,
	analyticsLinkId = null,
	ariaControls = null,
	onKeyDown = null,
}) => {
	const { config: { brand } = {} } = useContext(Context);
	const buttonName = analyticsLinkId ? `&lid=${analyticsLinkId}` : null;

	const renderButtonContent = () => {
		let text = title;
		if (link && linkContent) {
			text = linkContent.title;
		}

		return (
			<Fragment>
				{text && (
					<span className={`${mainClass}__gradient`}>
						<span className={`${mainClass}__text`}>{text}</span>
					</span>
				)}
				{children}
				{accessibleText && <AccessibleText>{accessibleText}</AccessibleText>}
			</Fragment>
		);
	};

	return link ? (
		<Link
			{...linkContent}
			className={getClasses({
				className,
				customStyles,
				brand,
				secondary,
				link,
			})}
			handleClick={onClick}
			role="button"
		>
			{renderButtonContent()}
		</Link>
	) : (
		<button
			id={elementId}
			aria-expanded={ariaExpanded}
			aria-label={ariaLabel}
			aria-controls={ariaControls}
			className={getClasses({
				className,
				customStyles,
				brand,
				secondary,
				link,
			})}
			onClick={(e) => {
				handleTriggerAnalytics(e, analyticsLinkId);
				onClick && onClick(e);
			}}
			onKeyDown={(e) => {
				onKeyDown && onKeyDown(e);
			}}
			onMouseEnter={(e) => {
				handleTriggerAnalytics(e, analyticsLinkId);
			}}
			tabIndex={tabIndex}
			disabled={disabled}
			style={style}
			name={buttonName}
		>
			{renderButtonContent()}
		</button>
	);
};

export default Button;
